export default "__VITE_ASSET__CbxOjTJI__"